import React from "react";

import { lazyImport } from "@common/hocs/lazyImport";
import { asyncWrapper } from "@common/hocs/asyncWrapper";
import { useSelector } from "react-redux";

const Tickets = asyncWrapper(lazyImport(() => import("@tickets")));

const TicketsWrapper = (props) => {
  const { verification, startupSettings } = useSelector((state) => state.terminal);
  const isVerificationDone = !startupSettings.IsPlayerVerificationEnabled || verification.isVerified;

  return <Tickets {...props} blockAllActions={isVerificationDone} />;
};

export default TicketsWrapper;
